

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.address', ['squid']).factory('$AddressNormalizationModel', function ($Model, $Api) {
        return $Model.extend('AddressNormalizationModel', {
            api: new $Api({
                uri: '/api/address/normalize'
            })
        });
    }).factory('$PrefillAddressModel', function ($Model, $Api) {
        return $Model.extend('PrefillAddressModel', {
            api: new $Api({
                uri: '/api/address/prefill'
            })
        });
    }).factory('$ValidateAddressModel', function ($Model, $Api) {
        return $Model.extend('ValidateAddressModel', {
            api: new $Api({
                uri: '/api/address/validate'
            })
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-models/src/address/index.js
 ** module id = 267
 ** module chunks = 1
 **/